module.exports = __webpack_public_path__ + "static/media/truck.ab97191c.svg";